(function () {
  'use strict';
  function getManager() {
    try {
      var E = window.Eraya;
      if (E && E.sdk && typeof E.sdk.getPriceTestManager === 'function') {
        return E.sdk.getPriceTestManager();
      }
    } catch (_) {}
    return null;
  }
  function rescan() {
    var mgr = getManager();
    if (mgr && typeof mgr.updatePricesOnCurrentPage === 'function') {
      try { mgr.updatePricesOnCurrentPage(); } catch (_) {}
    }
  }

  // 1. VARIANT CHANGE (Dawn pubsub, published synchronously after the
  //    #price-{section} morph, so this runs before paint => no flash).
  function onVariant(payload) {
    var d = payload && payload.data;
    var v = d && d.variant;
    var node = d && d.html && d.html.querySelector('[data-product-id]');
    if (!v || !node) return;
    var pid = node.getAttribute('data-product-id');
    document.querySelectorAll('[data-product-id="' + pid + '"]')
      .forEach(function (el) { el.setAttribute('data-variant-id', String(v.id)); });
    var mgr = getManager();
    // The theme just wrote the ORIGINAL price (same task). Keep it unpainted until the
    // test price is applied; only for products under a test so others never blink.
    var box = d.sectionId && document.getElementById('price-' + d.sectionId);
    var tested = false;
    try { tested = !!(mgr && mgr.hasProductTest && mgr.hasProductTest(pid)); } catch (_) {}
    if (box && tested) {
      box.style.visibility = 'hidden';
      setTimeout(function () { box.style.visibility = ''; }, 120); // ponytail: fixed delay, fail-open if SDK never answers
    }
    if (mgr && typeof mgr.updatePricesForProduct === 'function') {
      try { mgr.updatePricesForProduct(pid, String(v.id)); } catch (_) {}
    }
  }
  function hookVariant() {
    // constants.js declares PUB_SUB_EVENTS with `const` => a global binding, NOT window.PUB_SUB_EVENTS.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariant);
    }
  }
  hookVariant();

  // 2. DOOFINDER cards carry no product id/classes we can rely on, only a
  //    /products/<handle> link. Find the card by walking up from each link to the
  //    first ancestor holding an <img> and a price, tag card + price nodes with our
  //    own attributes (dashboard: Root [data-eraya-card], Price [data-eraya-price],
  //    Compare [data-eraya-compare]), resolve id via /products/<handle>.js, rescan.
  var PRICE_RE = /\d[\d.,\s]*\s?(€|\$|£|EUR|USD)|(€|\$|£)\s?\d/;
  var handleCache = {};
  function leafPrices(card) {
    var out = [].slice.call(card.querySelectorAll('*')).filter(function (e) {
      return e.children.length === 0 && PRICE_RE.test(e.textContent) && !e.closest('[data-eraya-ignore]');
    });
    out.forEach(function (e) {
      var struck = e.closest('s,del,strike') || getComputedStyle(e).textDecorationLine.indexOf('line-through') > -1;
      e.setAttribute(struck ? 'data-eraya-compare' : 'data-eraya-price', '');
    });
  }
  function stamp(a) {
    var card = a.parentElement;
    while (card && card !== document.body && !(card.querySelector('img') && PRICE_RE.test(card.textContent))) card = card.parentElement;
    if (!card || card === document.body || card.hasAttribute('data-eraya-card')) return;
    var u = new URL(a.href, location.origin);
    var m = u.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var h = m[1], qv = u.searchParams.get('variant');
    card.setAttribute('data-eraya-card', '');
    leafPrices(card);
    (handleCache[h] = handleCache[h] || fetch('/products/' + h + '.js').then(function (r) { return r.json(); }))
      .then(function (p) {
        var v = qv || (p.variants.filter(function (x) { return x.available; })[0] || p.variants[0]).id;
        card.setAttribute('data-product-id', String(p.id));
        card.setAttribute('data-variant-id', String(v));
        schedule();
      }).catch(function () { delete handleCache[h]; card.removeAttribute('data-eraya-card'); });
  }
  function stampDoofinder(n) {
    var links = n.matches && n.matches('a[href*="/products/"]') ? [n] : [];
    if (n.querySelectorAll) links = links.concat([].slice.call(n.querySelectorAll('a[href*="/products/"]')));
    links.forEach(function (a) { if (a.closest('[class*="dfd-"]')) stamp(a); });
  }

  // 3. AJAX CARDS / price re-renders: debounced rescan on added nodes.
  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(rescan, 150); }
  function relevant(n) {
    if (n.nodeType !== 1) return false;
    stampDoofinder(n);
    if (n.hasAttribute('data-product-id')) return true;
    return n.querySelector !== undefined && n.querySelector('[data-product-id]') !== null;
  }
  function start() {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var a = muts[i].addedNodes;
        for (var j = 0; j < a.length; j++) if (relevant(a[j])) schedule();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);

  // SDK loads async: rescan once ready (handles both event orders).
  if (window.ErayaReady) rescan();
  window.addEventListener('eraya:ready', function () { setTimeout(rescan, 0); });
})();
